import React from "react";
import { ShieldCheck, Users, Lock, Truck, RotateCcw, Gift } from "lucide-react";
import { USP_ITEMS } from "@/lib/data";

const iconMap = { ShieldCheck, Users, Lock, Truck, RotateCcw, Gift };

export default function USPStrip() {
  return (
    <section className="dyntra-container mt-3">
      <div className="rounded-2xl bg-white border border-gray-100 shadow-sm">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x divide-gray-100">
          {USP_ITEMS.map((u) => {
            const I = iconMap[u.icon];
            return (
              <div key={u.label} data-testid={`usp-${u.label.replace(/\s+/g, "-").toLowerCase()}`} className="flex items-center gap-3 p-5">
                <div className="h-10 w-10 rounded-full bg-[#F3EFFC] flex items-center justify-center shrink-0">
                  <I className="h-5 w-5 text-[#4B2AAD]" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900 leading-tight">{u.label}</p>
                  <p className="text-xs text-gray-500 leading-tight">{u.sub}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
